<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";
import CylinderTable from "@jntestapparatuur/cylinder/js/datatables/cylinder-table";

export default {
  mixins: [Datatable],
  components: {Link, App, Card},
  props: ['tableConfig', 'connectTableConfig', 'disconnectTableConfig'],
  methods: {
    initialiseDatatable() {



      if (!!this.$refs.table) {
        new CylinderTable({
          scope: this.$refs.table.$refs.table,
        });
      }

      if (!!this.$refs.disconnectTable) {
        new CylinderTable({
          scope: this.$refs.disconnectTable.$refs.table,
        });
      }

      if (!!this.$refs.connectTable) {
        new CylinderTable({
          scope: this.$refs.connectTable.$refs.table,
        });
      }
    }
  }
}
</script>

<template>
  <App title="Cilinders">
    <template v-if="$page.props.auth.permissions.includes('manage all cylinders')" #topButtons >
      <Link :href="route('cylinders.create')" class="btn btn-primary">
        <i class="bi bi-plus-lg"></i>
        Cilinder toevoegen
      </Link>
    </template>

    <Card class="mb-4" v-if="$page.props.auth.permissions.includes('manage all cylinders')">
      <Table ref="table" id="cylinders" :config="tableConfig"/>
    </Card>

    <Card class="mb-4" v-if="!$page.props.auth.permissions.includes('manage all cylinders')">
      <h2 class="card-title">Gekoppelde cilinders</h2>
      <Table ref="disconnectTable" id="cylinders2" :config="disconnectTableConfig"/>
    </Card>

    <Card class="mb-4" v-if="!$page.props.auth.permissions.includes('manage all cylinders')">
      <h2 class="card-title">Beschikbare cilinders</h2>
      <Table ref="connectTable" id="cylinders1" :config="connectTableConfig"/>
    </Card>
  </App>
</template>